/* Robles: página "Mis favoritos" (sections/rv-favoritos.liquid). Solo se carga en esa página.
   Usa window.rvFavoritos, que define assets/rv-favoritos.js (cargado antes en theme.liquid). */
(() => {
  const fav = window.rvFavoritos;
  if (!fav) return;
  // Shopify resuelve hasta 20 productos de all_products por petición.
  const POR_PETICION = 20;

  /* Formatea centavos con el formato de dinero de la tienda (ej. "$ {{amount}}"). */
  function formatoDinero(centavos, formato) {
    const numero = (decimales, miles, punto) => {
      const [entero, fraccion] = (centavos / 100).toFixed(decimales).split('.');
      return entero.replace(/\B(?=(\d{3})+(?!\d))/g, miles) + (fraccion ? punto + fraccion : '');
    };
    return (formato || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (coincidencia, tipo) => {
      if (tipo === 'amount_no_decimals') return numero(0, ',', '.');
      if (tipo === 'amount_with_comma_separator') return numero(2, '.', ',');
      if (tipo === 'amount_no_decimals_with_comma_separator') return numero(0, '.', ',');
      return numero(2, ',', '.');
    });
  }

  function agregarAlCarrito(items) {
    return fetch(`${window.routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    })
      .then((respuesta) => respuesta.json())
      .then((estado) => {
        if (estado.status) throw new Error(estado.description || estado.message || '');
        return estado;
      });
  }

  /* Actualiza el carrito lateral y la burbuja del header y abre el carrito, como el botón de las tarjetas. */
  function refrescarCarrito(origen) {
    const carrito = document.querySelector('cart-drawer');
    if (!carrito || typeof carrito.renderContents !== 'function') {
      window.location = window.routes.cart_url;
      return Promise.resolve();
    }
    const secciones = carrito.getSectionsToRender().map((seccion) => seccion.id);
    return fetch(`${window.routes.cart_url}?sections=${secciones.join(',')}`)
      .then((respuesta) => respuesta.json())
      .then((html) => {
        carrito.classList.remove('is-empty');
        if (typeof carrito.setActiveElement === 'function') carrito.setActiveElement(origen);
        carrito.renderContents({ sections: html });
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rv-favoritos' });
        }
      })
      .catch(() => {
        window.location = window.routes.cart_url;
      });
  }

  /* Página "Mis favoritos" (sections/rv-favoritos.liquid). */
  class RvFavoritos extends HTMLElement {
    connectedCallback() {
      if (this.iniciado) return;
      this.iniciado = true;
      this.lista = this.querySelector('[data-rv-fav-lista]');
      this.estado = this.querySelector('[data-rv-fav-estado]');
      this.vacio = this.querySelector('[data-rv-fav-vacio]');
      this.panel = this.querySelector('[data-rv-fav-panel]');
      this.barra = this.querySelector('[data-rv-fav-barra]');
      this.botonAgregar = this.querySelector('[data-rv-fav-agregar-todo]');

      // ?lista=handle-1,handle-2 abre una lista compartida (solo letras, números y guiones).
      const compartida = (new URLSearchParams(window.location.search).get('lista') || '')
        .split(',')
        .map((handle) => handle.trim().toLowerCase())
        .filter((handle) => /^[a-z0-9][a-z0-9-]*$/.test(handle));
      this.compartida = compartida.length ? [...new Set(compartida)].slice(0, fav.MAXIMO) : null;

      this.addEventListener('click', (evento) => {
        if (evento.target.closest('[data-rv-fav-agregar-todo]')) this.agregarTodo();
        else if (evento.target.closest('[data-rv-fav-cotizar]')) this.cotizar();
        else if (evento.target.closest('[data-rv-fav-compartir]')) this.compartir();
        else if (evento.target.closest('[data-rv-fav-guardar-lista]')) this.guardarLista(evento.target.closest('button'));
      });

      document.addEventListener('rv:favorito-quitado', (evento) => {
        if (this.compartida) return; // En una lista compartida las tarjetas se quedan.
        this.items().forEach((item) => {
          if (item.dataset.rvFavItem === evento.detail.handle) item.remove();
        });
        this.mostrarResultado();
      });

      if (this.compartida) this.prepararCompartida();
      this.cargar();
    }

    items() {
      return Array.from(this.lista.querySelectorAll('[data-rv-fav-item]'));
    }

    /* Los contadores de la página muestran la lista compartida, no los favoritos propios. */
    prepararCompartida() {
      const seccion = this.closest('.rv-favoritos') || this;
      const titulo = seccion.querySelector('[data-rv-fav-titulo-pagina]');
      if (titulo) titulo.textContent = 'Lista compartida';
      const subtitulo = seccion.querySelector('.rv-favoritos__subtitulo');
      if (subtitulo) subtitulo.hidden = true;
      seccion.querySelectorAll('[data-rv-fav-count]').forEach((contador) => {
        contador.dataset.rvFavCompartido = contador.dataset.rvFavCount;
        contador.removeAttribute('data-rv-fav-count');
      });
      this.querySelector('[data-rv-fav-compartida]').hidden = false;
    }

    async cargar() {
      const pedidos = this.compartida || fav.lista();
      if (pedidos.length === 0) {
        this.mostrarResultado();
        return;
      }

      const grupos = [];
      for (let i = 0; i < pedidos.length; i += POR_PETICION) {
        grupos.push(pedidos.slice(i, i + POR_PETICION));
      }

      try {
        const partes = await Promise.all(
          grupos.map((grupo) =>
            fetch(`${window.routes.collections_url}/all?view=ajax_favoritos&sort_by=${encodeURIComponent(grupo.join('||'))}`)
              .then((respuesta) => {
                if (!respuesta.ok) throw new Error(respuesta.status);
                return respuesta.text();
              })
              .then((texto) => {
                // Sin la marca de collection.ajax_favoritos no se confía en la respuesta
                // (evita borrar la lista si la plantilla falta o cambia).
                if (!texto.includes('<!--rv-favoritos-->')) throw new Error('plantilla');
                return texto;
              })
          )
        );
        this.lista.innerHTML = partes.join('');
      } catch (error) {
        this.mostrarMensaje('No pudimos cargar tus favoritos. Recarga la página para intentarlo de nuevo.');
        this.lista.hidden = true;
        this.panel.hidden = true;
        return;
      }

      // Agotados al final de la lista.
      this.items()
        .filter((item) => item.dataset.rvFavDisponible !== 'true')
        .forEach((item) => this.lista.appendChild(item));

      // Olvidar productos eliminados o despublicados para que el contador coincida.
      if (!this.compartida) {
        const encontrados = new Set(this.items().map((item) => item.dataset.rvFavItem));
        const actuales = fav.lista();
        const vigentes = actuales.filter((handle) => !pedidos.includes(handle) || encontrados.has(handle));
        if (vigentes.length !== actuales.length) fav.reemplazar(vigentes);
      }

      if (typeof initImageScale === 'function') initImageScale();
      this.mostrarResultado();
    }

    mostrarResultado() {
      const items = this.items();
      const hayProductos = items.length > 0;
      this.estado.hidden = true;
      this.lista.hidden = !hayProductos;
      this.panel.hidden = !hayProductos;
      this.vacio.hidden = hayProductos || Boolean(this.compartida);
      if (this.compartida) {
        this.pintarContadoresCompartida(items.length);
        if (!hayProductos) this.mostrarMensaje('Los productos de esta lista ya no están disponibles.');
      }
      if (hayProductos) this.actualizarResumen(items);
    }

    /* El estado queda oculto a la vista mientras se ven los esqueletos; un mensaje lo muestra. */
    mostrarMensaje(texto) {
      this.estado.textContent = texto;
      this.estado.classList.remove('visually-hidden');
      this.estado.hidden = false;
    }

    pintarContadoresCompartida(total) {
      (this.closest('.rv-favoritos') || this).querySelectorAll('[data-rv-fav-compartido]').forEach((contador) => {
        const formato = contador.dataset.rvFavCompartido;
        contador.textContent = fav.textoContador(formato, total);
        contador.hidden = total === 0;
      });
    }

    /* Total de los productos disponibles y cuántos se pueden agregar directo. */
    actualizarResumen(items) {
      const disponibles = items.filter((item) => item.dataset.rvFavDisponible === 'true');
      const agregables = disponibles.filter((item) => item.dataset.rvFavVariante);
      const total = disponibles.reduce((suma, item) => suma + (Number(item.dataset.rvFavPrecio) || 0), 0);
      const moneda = this.dataset.moneda || '';

      this.barra.hidden = disponibles.length === 0;
      this.querySelector('[data-rv-fav-monto]').textContent = formatoDinero(total, this.dataset.moneyFormat).replace(moneda, '').trim();
      this.querySelector('[data-rv-fav-moneda]').textContent = moneda;
      this.querySelector('[data-rv-fav-desde]').hidden = !disponibles.some((item) => item.dataset.rvFavDesde === 'true');
      this.querySelector('[data-rv-fav-agregables]').textContent = `(${agregables.length})`;
      this.botonAgregar.hidden = agregables.length === 0;
      // En celular flota solo con más de una fila (3+ productos) y algo que agregar.
      this.barra.classList.toggle('rv-fav-barra--flotante', items.length > 2 && agregables.length > 0);
    }

    async agregarTodo() {
      const boton = this.botonAgregar;
      if (boton.getAttribute('aria-busy') === 'true') return;
      const disponibles = this.items().filter((item) => item.dataset.rvFavDisponible === 'true');
      const pedidos = disponibles
        .filter((item) => item.dataset.rvFavVariante)
        .map((item) => ({ id: Number(item.dataset.rvFavVariante), quantity: Number(item.dataset.rvFavCantidad) || 1 }));
      if (pedidos.length === 0) return;

      boton.setAttribute('aria-busy', 'true');
      let agregados = 0;
      let ultimoError = '';
      try {
        await agregarAlCarrito(pedidos);
        agregados = pedidos.length;
      } catch (error) {
        // Si uno falla (por ejemplo, sin existencias suficientes), se agregan uno por uno.
        for (const pedido of pedidos) {
          try {
            await agregarAlCarrito([pedido]);
            agregados += 1;
          } catch (errorUno) {
            ultimoError = errorUno.message;
          }
        }
      }
      boton.removeAttribute('aria-busy');

      if (agregados === 0) {
        fav.avisar(ultimoError || 'No pudimos agregar los productos. Intenta de nuevo.');
        return;
      }
      await refrescarCarrito(boton);

      let texto = agregados === 1 ? '1 producto agregado al carrito' : `${agregados} productos agregados al carrito`;
      if (agregados < pedidos.length) {
        texto = `Agregamos ${agregados} de ${pedidos.length}. ${ultimoError}`.trim();
      } else if (disponibles.length > pedidos.length) {
        texto += '. Elige la presentación de los demás en su tarjeta.';
      }
      fav.avisar(texto);
    }

    /* Abre WhatsApp con la lista lista para cotizar. */
    cotizar() {
      const numero = (this.dataset.whatsapp || '').replace(/\D/g, '');
      if (!numero) return;
      const lineas = this.items().map((item) => {
        const enlace = new URL(item.dataset.rvFavUrl, window.location.origin).href;
        const agotado = item.dataset.rvFavDisponible === 'true' ? '' : ' (agotado)';
        return `• ${item.dataset.rvFavTitulo}${agotado} — ${enlace}`;
      });
      const texto = `Hola, quiero cotizar estos productos de mi lista de favoritos:\n${lineas.join('\n')}`;
      window.open(`https://api.whatsapp.com/send?phone=${numero}&text=${encodeURIComponent(texto)}`, '_blank', 'noopener');
    }

    /* Enlace que abre esta misma lista en otro dispositivo. */
    async compartir() {
      // Los handles solo llevan letras, números y guiones: las comas pueden ir sin codificar.
      const enlace = new URL(window.location.pathname, window.location.origin);
      enlace.search = `?lista=${this.items().map((item) => item.dataset.rvFavItem).join(',')}`;
      if (navigator.share) {
        try {
          await navigator.share({ title: document.title, text: 'Mi lista de favoritos', url: enlace.href });
        } catch (error) {
          // El cliente cerró el menú de compartir.
        }
        return;
      }
      try {
        await navigator.clipboard.writeText(enlace.href);
        fav.avisar('Enlace de tu lista copiado');
      } catch (error) {
        window.prompt('Copia el enlace de tu lista:', enlace.href);
      }
    }

    /* Lista compartida: guarda sus productos en los favoritos propios. */
    guardarLista(boton) {
      const actuales = fav.lista();
      const nuevos = this.items()
        .map((item) => item.dataset.rvFavItem)
        .filter((handle) => !actuales.includes(handle));
      fav.reemplazar([...nuevos, ...actuales]);
      if (nuevos.length === 0) fav.avisar('Ya tenías estos productos en tus favoritos');
      else fav.avisar(nuevos.length === 1 ? '1 producto guardado en tus favoritos' : `${nuevos.length} productos guardados en tus favoritos`);
      if (boton) boton.hidden = true;
    }
  }

  if (!customElements.get('rv-favoritos')) customElements.define('rv-favoritos', RvFavoritos);
})();
